import { createSelector } from 'reselect';
import { formatCurrency } from '../../utils/currency.utils';
import { selectCompanyCurrency, selectCompanyCurrencyCulture } from './auth.selector';
export const selectTripFeatureState = (state) => state.search;

export const selectTripResults = createSelector(
  selectTripFeatureState,
  (state) => state.tripResults
);
export const selectTripSummary = createSelector(
  selectTripFeatureState,
  (state) => state.tripSummary
);

export const selectActiveComponentIndex = createSelector(
  selectTripFeatureState,
  (state) => state.activeRequestedComponentIndex
);

export const selectChangeRes = createSelector(
  selectTripFeatureState,
  (state) => state && state.changeResTrip
);

export const selectSearchOriginScreen = createSelector(
  selectTripFeatureState,
  (state) => state.searchOriginScreen
);

export const selectLowFares = createSelector(
  selectTripFeatureState,
  (state) => state && state.lowFares
);

export const selectSearchInput = createSelector(
  selectTripFeatureState,
  (state) => state && state.searchInput
);
export const selectTripName = createSelector(
  selectTripFeatureState,
  (state) => state && state.tripName
);

export const selectIsCarCitySearch = createSelector(
  selectTripResults,
  (state) => state?.IsCityCarSearch
);

export const selectPolicyException = createSelector(
  selectTripResults,
  (state) => state?.RequestedComponents
);

export const selectIsCarAirportSearch = createSelector(
  selectTripResults,
  (state) => state?.IsAirportCarSearch
);

export const selectIsMultiCity = createSelector(selectSearchInput, (state) => {
  if (!state) {
    return false;
  }

  return state?.searchCriteria && state.searchCriteria.length > 1;
});

export const selectIsOnlyHotelMultiLegTrip = createSelector(selectSearchInput, (state) => {
  if (!state) {
    return false;
  }
  return (
    state?.searchCriteria &&
    state.searchCriteria.length > 1 &&
    !state.hasAir &&
    !state.hasCar &&
    state.hasHotel
  );
});

export const selectSearchCriteriaByComponentIndex = createSelector(
  selectSearchInput,
  selectActiveComponentIndex,
  (state, index) => {
    if (!state) {
      return state;
    }

    return state?.searchCriteria?.[index - 1];
  }
);

export const selectRequestComponentByComponentIndex = createSelector(
  selectTripResults,
  selectActiveComponentIndex,
  (state, index) => {
    if (!state) {
      return state;
    }

    return state?.RequestedComponents?.[index - 1];
  }
);

export const selectFirstAndLastDateOfSearchCriteria = createSelector(selectSearchInput, (state) => {
  if (!state?.searchCriteria) {
    return state;
  }
  return {
    fromDate: state.searchCriteria[0].fromDate,
    toDate: state.searchCriteria[state.searchCriteria.length - 1].toDate,
  };
});

export const selectFirstAndLastDateOfSearchCriteriaMultiCity = createSelector(
  selectSearchInput,
  (state) => {
    if (!state?.searchCriteria) {
      return state;
    }
    return {
      fromDate: state.searchCriteria[0].fromDate,
      toDate: state.searchCriteria[state.searchCriteria.length - 1].fromDate,
    };
  }
);

export const selectFirstSearchCriteria = createSelector(
  selectSearchInput,
  (state) => state?.searchCriteria && state.searchCriteria[0]
);

const getLowFareStyle = (avgPrice, minPrice) => {
  if (parseInt(minPrice) < parseInt(avgPrice)) {
    return 'below';
  }

  if (parseInt(minPrice) > parseInt(avgPrice)) {
    return 'above';
  }

  if (parseInt(minPrice) == parseInt(avgPrice)) {
    return 'equal';
  }
};

export const selectLowFarePriceMap = createSelector(
  selectLowFares,
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
  (state, currency, currencyCulture) => {
    if (!state?.fareResponse) {
      return undefined;
    }
    return state.fareResponse.reduce((result, lowFare) => {
      result[lowFare.departureDateTime] = {
        price: formatCurrency(lowFare.price, currency, currencyCulture),
        styleKey: getLowFareStyle(state.avgPrice, lowFare.price),
      };
      return result;
    }, {});
  }
);

export const selectAirRepriceError = createSelector(
  selectTripFeatureState,
  (state) => state?.travelCart?.ErrorMessage
);

export const selectLocationDetail = createSelector(
  selectTripFeatureState,
  (state) => state.locationDetail
);

export const selectNoOfTravelers = createSelector(
  selectTripFeatureState,
  (state) => state?.travelCart?.Passengers?.length
);

export const selectIsRedisKeyPresent = createSelector(
  selectTripResults,
  (state) => state?.RequestedComponents[0]?.RedisCacheKey?.length > 0
);

export const selectHomepageUDIDvalues = createSelector(
  selectTripFeatureState,
  (state) => state && state?.homepageUDIDdata
);
